module.exports = __webpack_public_path__ + "img/下载.10cf4122.svg";